import { toast } from "react-toastify";
import "./style.css";
/**
 * Notificar
 * @param {string} tipo tipo de notificación, info/success/error/warn
 * @param {string} msg mensaje
 * @param {integer} autoClose delay en milisegundos
 */

export function Notificar(tipo = null, msg, autoClose = null) {
  const posicion = toast.POSITION.TOP_CENTER;

  switch (tipo) {
    case "success":
      toast.success(msg, {
        autoClose: autoClose === null ? 20000 : autoClose,
        position: posicion,
        toastId: "MensajeExitoso",
      });
      break;
    case "error":
      let toastId = toast.error("");

      toast.update(toastId, {
        render: (
          <div
            dangerouslySetInnerHTML={{ __html: ConstruirMensajeError(msg) }}
          />
        ),
        autoClose: autoClose === null ? 20000 : autoClose,
        position: posicion,
        type: toast.TYPE.ERROR,
        toastId: "MensajeError",
      });
      break;
    case "warn":
      toast.warn(msg, {
        autoClose: autoClose === null ? 1000 : autoClose,
        position: posicion,
        toastId: "MensajeAdvertencia",
        delay: autoClose === null ? 1 : autoClose / 1000,
      });
      break;
    case "info":
    default:
      toast.info(msg, {
        autoClose: autoClose === null ? 5000 : autoClose,
        position: posicion,
        toastId: "MensajeInfo",
      });
  }
}

export function CerrarNotificador() {
  toast.dismiss();
}

function ConstruirMensajeError(mensaje) {
  let resultado = "";

  switch (true) {
    case mensaje === undefined:
      resultado = "Ha ocurrido un error no controlado.";
      break;
    case Array.isArray(mensaje) && mensaje.length === 1:
      resultado = mensaje[0];
      break;
    case Array.isArray(mensaje):
      resultado = "<ul class='m-0'>";
      mensaje.forEach((msj) => (resultado += "<li>" + msj + "</li>"));
      resultado += "</ul>";
      break;
    default:
      resultado = mensaje;
  }

  return resultado;
}
